export default {
    yes: "Ja",
    no: "Nee"
}